import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './Pages/Home';
import SouthernGroundedHornbill from './Pages/SouthernGroundedHornbill';
import AfricanPenguin from './Pages/AfricanPenguin';
import PelsFishingOwl from './Pages/PelsFishingOwl';
import SaddleBilledStork from './Pages/SaddleBilledStork';
import BeardedVulture from './Pages/BeardedVulture';
import CapeGannet from './Pages/CapeGannet';
import About from './Pages/About';
import Solution from './Pages/Solution';
import Contact from './Pages/Contact';
import Donate from './Pages/Donate';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsOfService from './Pages/TermsOfService';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/southern-grounded-hornbill" element={<SouthernGroundedHornbill />} />
          <Route path="/african-penguin" element={<AfricanPenguin />} />
          <Route path="/pels-fishing-owl" element={<PelsFishingOwl />} />
          <Route path="/saddle-billed-stork" element={<SaddleBilledStork />} />
          <Route path="/bearded-vulture" element={<BeardedVulture />} />
          <Route path="/cape-gannet" element={<CapeGannet />} />
          <Route path="/about" element={<About />} />
          <Route path="/solution" element={<Solution />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
